import type { FC } from 'react'

import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'
import type { InjuryType } from '@/app/types'

const PoliceAndInsuranceRef: FC<{ injuryType: InjuryType | string; isEditable: boolean }> = ({
  injuryType,
  isEditable,
}) => {
  if (!['LOSS', 'THEFT'].includes(injuryType)) return null

  return (
    <section>
      <h3>
        <Text id="Referanser" />
      </h3>

      <Field name="insuranceRef">
        {({ field, meta }: FieldProps) => (
          <Input
            id="insuranceRef"
            label={<Text id="Insurance company referance" />}
            error={meta.error}
            marginBottom={16}
            touched={meta.touched}
            isDisabled={!isEditable}
            {...field}
          />
        )}
      </Field>

      {injuryType === 'THEFT' && (
        <Field name="policeReportRef">
          {({ field, meta }: FieldProps) => (
            <Input
              id="policeReportRef"
              label={<Text id="Police reference (report)" />}
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              {...field}
            />
          )}
        </Field>
      )}
    </section>
  )
}

export default PoliceAndInsuranceRef
